import type { GPSCoords } from "@/lib/image-utils";
import { createTargetSvg } from "@/lib/svg-utils";
import React, { useEffect, useState } from "react";

const GoogleMapPin: React.FC<{ coords: GPSCoords; onChange: (coords: GPSCoords) => void;}> = ({ coords, onChange }) => {
  const mapRef = React.useRef<HTMLDivElement>(null);
  const markerRef = React.useRef<any>(null);
  const [mapLoaded, setMapLoaded] = React.useState(false);
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'AIzaSyAIBkOxVb7yYC4kwmcEASEmb5PpKkS01t0';

    useEffect(() => {
      if (window.google && window.google.maps) {
        setGoogleMapsLoaded(true);
        return;
      }
      const scriptId = "google-maps-script";
      if (document.getElementById(scriptId)) return;
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
      script.async = true;
      script.onload = () => setGoogleMapsLoaded(true);
      document.body.appendChild(script);
    }, []);

  React.useEffect(() => {  
    if (!mapLoaded && window.google && window.google.maps) {
      setMapLoaded(true);
    }
    console.log("coords:", coords);
    if (!mapRef.current || !window.google || !window.google.maps) return;
    const map = new google.maps.Map(mapRef.current, {
      center: { lat: coords.latitude!, lng: coords.longitude! },
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.SATELLITE,
      streetViewControl: false,
      fullscreenControl: false,
    });

    // Add custom button to map controls
    const locationButton = document.createElement("button");
    locationButton.type = "button";
    locationButton.className = "text-center bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-gray-200 p-2 z-10";
    locationButton.style.margin = "8px";
    locationButton.insertBefore(createTargetSvg(), locationButton.firstChild);
    locationButton.onclick = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            onChange({ latitude, longitude });
          },
          () => {
            alert("Unable to retrieve your location.");
          }
        );
      } else {
        alert("Geolocation is not supported by your browser.");
      }
    };
    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(locationButton);
    const marker = new google.maps.Marker({
      position: { lat: coords.latitude!, lng: coords.longitude! },
      map,
      draggable: true,
    });
    marker.addListener("dragend", (e: any) => {
      const newLat = e.latLng.lat();
      const newLng = e.latLng.lng();
      onChange({ latitude: newLat, longitude: newLng });
    });
    markerRef.current = marker;
    return () => {
      marker.setMap(null);
    };
  }, [coords, mapLoaded]);

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={mapRef}
        style={{ width: "100%", height: "400px", borderRadius: "8px" }}
      />
      {(!mapLoaded || !googleMapsLoaded) && (
        <div className="text-center text-gray-500">Loading Google Maps...</div>
      )}
    </div>
  );
};

export default GoogleMapPin;
